module.exports = __webpack_public_path__ + "static/media/cec.7d41ec68.JPG";